export default __webpack_public_path__ + "static/media/7.RUPAYANSHOPPINGSQUARE.da16067e.jpg";